module.exports = __webpack_public_path__ + "static/media/mars-stroke.9c28b268.svg";